import { Alert, Checkbox, Snackbar } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { Service, updateServicePaymentStatusByID } from "src/apis/services";

type ServicePaidCheckCellProps = {
  isAdmin: boolean,
  service: Service,
  setError: (err: string) => void,
}

const ServicePaidCheckCell: FC<ServicePaidCheckCellProps> = ({
  isAdmin,
  service,
  setError = (ignored: string) => {},
}) => {
  const [checked, setChecked] = useState<boolean>(Boolean(service?.pago));
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [unblockedMessage, setUnblockedMessage] = useState<string>('');

  useEffect(() => {
    setChecked(Boolean(service?.pago));
  }, [service?.pago]);

  const toggleServicePaymentStatus = async (reason: string) => {
    const nextPaymentStatus = !checked;

    setIsLoading(true);

    try {
      const result = await updateServicePaymentStatusByID(
        service?.id_psicologo,
        service?.id_atendimento,
        nextPaymentStatus,
        reason,
      );

      setError('');
      setChecked(nextPaymentStatus);

      if (result?.colaborador_desbloqueado) {
        setUnblockedMessage(
          `${service?.colaborador || 'O colaborador'} quitou todas as sessões em aberto e foi desbloqueado automaticamente.`,
        );
      }
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Erro ao atualizar o pagamento do atendimento.';

      setError(message);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <Checkbox
        disabled={!isAdmin || isLoading}
        checked={checked}
        title={isAdmin ? (checked ? "Marcar como não pago" : "Marcar como pago") : "Pago?"}
        onClick={() => {
          const confirmMessage = checked
            ? `Deseja mesmo marcar esse atendimento (ID ${service?.id_atendimento}) como não pago?`
            : `Deseja mesmo marcar esse atendimento (ID ${service?.id_atendimento}) como pago?`;
          const reasonMessage = checked
            ? `Por qual motivo deseja marcar esse atendimento (ID ${service?.id_atendimento}) como não pago?`
            : `Por qual motivo deseja marcar esse atendimento (ID ${service?.id_atendimento}) como pago?`;

          if (window.confirm(confirmMessage)) {
            let reason = '';
            while (String(reason).trim()?.length === 0) {
              reason = window.prompt(reasonMessage) ?? '';
            }

            toggleServicePaymentStatus(reason);
          }
        }}
      />

      <Snackbar
        open={Boolean(unblockedMessage)}
        autoHideDuration={6000}
        onClose={() => setUnblockedMessage('')}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity="success" onClose={() => setUnblockedMessage('')}>
          {unblockedMessage}
        </Alert>
      </Snackbar>
    </>
  )
}

export default ServicePaidCheckCell;
